export const ACCOUNT_MAIN_CURRENCY = 'AKZ'

export const ACCOUNT_TYPES = {
	DO: 'DO',
	DWALLET: 'DWALLET',
	CCO: 'CCO',
	CRR: 'CRR',
	CRF: 'CRF'
}

export const ACCOUNT_FAMILIES = {
	liabilities: 'liabilities',
	assets: 'assets'
}
